import { SidebarLeftIcon } from "src/assets/icons/sidebar-left";
import { LogoCircle } from "src/assets/icons/logo-circle";
import { Logo } from "src/components/Logo";
import UserOptionSelector from "./UserOptionSelector";
import MenuItem from "./MenuItem";
import {
  LeftDrawerContainer,
  PorchPassLogo,
  ButtonWrapper,
  CollapseButton,
  CollapseDivider,
  MenuContainer,
  LogoLink,
  AdminLabel,
} from "./AdminLeftDrawer.styles";

interface AdminLeftDrawerProps {
  page: string;
  isCollapsed: boolean;
  onToggleCollapsed: () => void;
}

export default function AdminLeftDrawer({
  page,
  isCollapsed,
  onToggleCollapsed,
}: AdminLeftDrawerProps) {
  return (
    <LeftDrawerContainer isCollapsed={isCollapsed}>
      <PorchPassLogo isCollapsed={isCollapsed}>
        <LogoLink to="/pre-approval" isCollapsed={isCollapsed}>
          {isCollapsed ? <LogoCircle width={30} height={30} /> : <Logo />}
          <AdminLabel isCollapsed={isCollapsed}>Admin Tools</AdminLabel>
        </LogoLink>
        {!isCollapsed && (
          <CollapseButton onClick={onToggleCollapsed} isCollapsed={isCollapsed}>
            <SidebarLeftIcon width={18} height={16} />
          </CollapseButton>
        )}
      </PorchPassLogo>
      {isCollapsed && (
        <>
          <ButtonWrapper>
            <CollapseButton
              onClick={onToggleCollapsed}
              isCollapsed={isCollapsed}
            >
              <SidebarLeftIcon width={18} height={16} />
            </CollapseButton>
          </ButtonWrapper>
          <CollapseDivider />
        </>
      )}
      <MenuContainer>
        <MenuItem
          forPage="pre-approval"
          isCurrent={page === "pre-approval"}
          isCollapsed={isCollapsed}
        />
        <MenuItem
          forPage="conditions-inbox"
          isCurrent={page === "conditions-inbox"}
          isCollapsed={isCollapsed}
        />
        <MenuItem
          forPage="rcm"
          isCurrent={page === "rcm"}
          isCollapsed={isCollapsed}
        />
      </MenuContainer>

      <UserOptionSelector isDrawerCollapsed={isCollapsed} />
    </LeftDrawerContainer>
  );
}
